import angular, { IDirective, IScope } from "angular";
import { ChartJsDirectiveController } from "./controller";
import { ChartConfiguration } from "chart.js";
import { Chart } from "chart.js";

export const vsDirectiveName = "chartJs";

interface chartJsDirectiveScope extends IScope {
  config: ChartConfiguration;
}

export function chartJsDirective(): IDirective {
  return {
    restrict: "E",
    bindToController: {
      config: "<",
    },
    controller: ChartJsDirectiveController,
    link: {
      pre(scope, jQuery, attrs, controller) {
        const canvasElement = angular.element("<canvas></canvas>");
        jQuery.append(canvasElement);

        const ctx = (canvasElement[0] as HTMLCanvasElement)?.getContext("2d")!;
        let chart: Chart;

        const watcher = scope.$watch(
          (s) => (<ChartJsDirectiveController>controller).config,
          (newValue) => {
            chart?.destroy();
            if (!newValue) {
              return;
            }
            chart = new Chart(ctx, newValue);
          }
        );

        scope.$on("$destroy", () => {
          watcher();
          chart?.destroy();
        });
      },
    },
  };
}
chartJsDirective.$inject = <string[]>[];
